import socialMediaConfig from '@/assets/common/social-media-config';
import { SOCIAL_MEDIA_PRIMARY_ICON_VARIANT } from '@/assets/common/social-media-config';

const YOUTUBE_ID = 5;

class SocialMediaHandlerService {
    constructor() {
        this.socialMedia = socialMediaConfig.getAll();

        this.defaultName = 'All Networks';

        this.defaultColor = 'black';

        this.defaultIcon = require('@/assets/images/network-logos/placeholder-network.svg');

        this.allSocialMediaIds = this.socialMedia.map(({ id }) => id);
    }

    // @NOTE Yoav (Sentiment Settings)
    getSocialMediaCollectionAsOptions() {
        return this.socialMedia.map(({ id, name }) => ({ label: name, value: id }));
    }

    getConfigByKey(key) {
        const index = Object.keys(socialMediaConfig).findIndex(socialMediaKey => socialMediaKey === key);

        if (~index) {
            return this.socialMedia[index];
        }

        return null;
    }

    getConfigById(id) {
        return this.socialMedia.find(socialMedia => socialMedia.id === id);
    }

    getConfigByIdFormatted(id) {
        let config = this.getConfigById(id);

        if (id === YOUTUBE_ID) {
            config = {
                ...config,
                name: 'Youtube'
            }
        }

        return config;
    }

    getNameByIdFormatted(id) {
        let name  = this.getNameById(id);

        if (id === YOUTUBE_ID) {
            return 'Youtube'
        }

        return name;
    }

    getNameById(id) {
        const socialMedia = this.getConfigById(id);

        return socialMedia ? socialMedia.name : this.defaultName;
    }

    getNameByKey(key) {
        const socialMedia = this.getConfigByKey(key);

        return socialMedia ? socialMedia.name : this.defaultName;
    }

    getIconById(id, variant = SOCIAL_MEDIA_PRIMARY_ICON_VARIANT) {
        const socialMedia = this.getConfigById(id);

        return socialMedia ? socialMedia.icons[variant] : this.defaultIcon;
    }

    getIconByKey(key, variant = SOCIAL_MEDIA_PRIMARY_ICON_VARIANT) {
        const socialMedia = this.getConfigByKey(key);

        return socialMedia ? socialMedia.icons[variant] : this.defaultIcon;
    }

    getColorById(id) {
        const socialMedia = this.getConfigById(id);

        return socialMedia ? socialMedia.color : this.defaultColor;
    }

    getColorByKey(key) {
        const socialMedia = this.getConfigByKey(key);

        return socialMedia ? socialMedia.color : this.defaultColor;
    }
}

export default SocialMediaHandlerService;
